export default __webpack_public_path__ + "static/media/bannerFour.88c0d701.png";